<template>
  <div v-show="field.isVisible">
    <DocumentFieldString
      v-if="field.type == 0"
      :field.sync="field"
      :validator.sync="validator"
      :index="index"
      :disabled="disabled"
      :ctIndex="ctIndex"
    />
    <DocumentFieldDatetime
      v-if="field.type == 1"
      :field.sync="field"
      :validator.sync="validator"
      :index="index"
      :disabled="disabled"
      :ctIndex="ctIndex"
    />
    <DocumentFieldNumeric
      v-if="field.type == 2"
      :field.sync="field"
      :validator.sync="validator"
      :index="index"
      :disabled="disabled"
      :ctIndex="ctIndex"
    />
    <DocumentFieldList
      :ref="listFieldKey"
      v-if="field.type >= 3"
      :field.sync="field"
      :validator.sync="validator"
      :index="index"
      :disabled="disabled"
      :ctIndex="ctIndex"
      :canAddData="canAddData"
    />
  </div>
</template>
<script>
import DocumentFieldString from "@/components/document/documentModal/field/types/DocumentFieldString";
import DocumentFieldNumeric from "@/components/document/documentModal/field/types/DocumentFieldNumeric";
import DocumentFieldDatetime from "@/components/document/documentModal/field/types/DocumentFieldDatetime";
import DocumentFieldList from "@/components/document/documentModal/field/types/DocumentFieldList";

export default {
  components: {
    DocumentFieldString,
    DocumentFieldList,
    DocumentFieldNumeric,
    DocumentFieldDatetime,
  },
  props: {
    documentId: {
      type: Number,
    },
    field: {
      type: Object,
    },
    index: {
      type: Number,
    },
    ctIndex: {
      type: Number,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    validator: {
      type: Object,
      default: () => ({}),
    },
    canAddData: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      listFieldKey: "listFieldKey",
    };
  },
  computed: {
    isReadOnly() {
      return this.field.isReadOnly && this.documentId > 0;
    },
    listFieldInstance() {
      return this.$refs[this.listFieldKey];
    },
  },
  methods: {
    refreshListElements(parameters) {
      this.listFieldInstance.getListElements(parameters);
    },
  },
  watch: {
    "field.value": {
      immediate: true,
      handler(val, oldVal) {
        this.$emit("on-field-change", this.field);
      },
    },
  },
};
</script>